const countries = `{
    countries {
        id
        full_name_locale
        available_regions {
            id
            code
            name
        }
        available_for_shipping
        available_for_billing
    }
}`;

export default {
    countries
};
